<div class="wrapper shadowed" >
    <div id="paragraphe">
        <h4>Gestion de l'arbre du "Guide de réussite"</h4>
        <div class="container">
            <button (click)="doShowAll(true)" class="btn show" *ngIf="!showAll">Tout voir</button>
            <button (click)="doShowAll(false)" class="btn show" *ngIf="showAll">Replier</button>
            <button (click)="newElement()" class="btn endOf">Nouveau</button>
           
        </div>
        <h5>Arbre actuel</h5>
        <ng-container *ngIf="rootOfTree">
            <button (click)="editMachine()" class="btn btn-primary">{{rootOfTree.label}}</button>
            <app-arbre-component [composant]="rootOfTree" (reloadEvent)='updateTree()'  [forEdition]=true [showAll]="showAll"></app-arbre-component>
        </ng-container>
    </div>
    <br>
</div>